import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import CONFIG from '../../config';
import Header from '../ui/Header';
// import Courses from './Courses';
import Footer from '../ui/Footer';
// import InfoBar from '../Home/Info';
import browserDetect from '../../utils/browserDetect';
// import { setFCUserProperties, destroyChat } from '../../utils/chat';
import { getParams } from '../../utils';
import firstVisited from '../../utils/firstVisited';
import { Input } from '../ui/Input/input';
import TextArea from '../ui/Input/textarea';
import Button from '../ui/Button/button';
import { ButtonLoader } from '../ui/Loader';
import styled from 'styled-components';
import './b2blanding.css';
import Axios from 'axios';
import HeaderSnackbar from '../Account/HeaderSnackbar';

// Gneral Focus Hook
const utilizeFocus = () => {
  const ref = React.createRef();
  const setFocus = () => {
    ref.current && ref.current.focus();
  };

  return { setFocus, ref };
};

const InputField = styled.input`
  font-size: 14px;
  color: var(--inputTxtColor);
  background: #fff;
  width: 100%;
  height: 40px;
  border: 1px solid var(--greyBorderColor);
  border-radius: 4px;
  padding-left: 10px;
  margin-bottom: 24px;
  :hover {
    outline: none;
    border: 1px solid var(--brandColor);
  }
  :focus {
    outline: none;
    border: 2px solid var(--brandColor);
  }
  @media (min-width: 768px) {
    padding-left: 12px;
  }
`;

class Home extends Component {
  constructor(props) {
    super(props);
    this.input1Focus = utilizeFocus();
    this.input2Focus = utilizeFocus();
  }
  state = {
    browser: '',
    infoStatus: false,
    name: '',
    companyName: '',
    companyMailID: '',
    title: '',
    phoneNumber: '',
    requirementDescription: '',
    loading: false,
    errors: {
      name: false,
      companyName: false,
      companyMailID: false,
      title: false,
      phoneNumber: false,
      requirementDescription: false,
    },
    replyMessage: '',
    errorStatus: false,
    headerSnackbar: false,
    yearEndOffer: true,
    scrolling: false,
  };

  async componentDidMount() {
    firstVisited();
    const { userID, email, history } = this.props;

    window.addEventListener('scroll', this.handleScroll);

    if (userID !== null) {
      history.push('/dashboard');
    }

    // document.addEventListener('contextmenu', this.handleContextMenu);

    // Initialise the chatbot
    // const name = this.props.name.split(' ');
    // const firstName = name[0];
    // const lastName = name[1];
    // window.fcWidget && setFCUserProperties(userID, firstName, lastName, email);

    let sBrowser = browserDetect();
    this.setState({ browser: sBrowser });

    // Show info bar
    setTimeout(() => {
      this.setState({ infoStatus: false });
    }, 1500);

    //get referrer url and store in local storage
    const url = window.location.search;
    const referrer_medium = getParams(url);
    url && localStorage.setItem('referrer_medium', JSON.stringify({ ...referrer_medium, medium: document.referrer }));
  }

  componentWillUnmount() {
    // // Destroy the chatbot
    //   destroyChat();
    window.removeEventListener('scroll', this.handleScroll);
  }

  // handleContextMenu = (event) => {
  //   event.preventDefault();
  // };

  // validateEmail(elementValue){
  //     var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  //     return emailPattern.test(elementValue);
  //   }

  validateEmail = (email) => {
    const { companyMailID } = this.state;
    let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (regex.test(email)) {
      this.setState({
        companyMailID: email,
        errors: {
          ...this.state.errors,
          companyMailID: false,
        },
      });
    } else {
      this.setState({
        companyMailID: email,
        errors: {
          ...this.state.errors,
          companyMailID: true,
        },
      });
    }
  };

  handleInfoBar = () => {
    this.setState({ infoStatus: false });
  };

  _focusFirstInput() {
    this.input1Focus.setFocus();
  }

  focusForm() {
    var element = document.getElementById('b2bForm');
    element.classList.add('shake');

    var delay = setTimeout(function() {
      element.classList.remove('shake');
    }, 3000);
    this._focusFirstInput();
  }

  validateMobile = (mobile) => {
    let regex = /^[0-9]*$/;
    if (regex.test(mobile)) {
      this.setState({
        phoneNumber: mobile,
        errors: {
          ...this.state.errors,
          phoneNumber: mobile.length < 6,
        },
      });
    }
  };

  canBeSubmitted() {
    const { name, companyMailID, companyName, title, phoneNumber, requirementDescription } = this.state.errors;
    return name === false && companyMailID === false && companyName === false && title === false && phoneNumber === false && requirementDescription === false;
  }

  _submitData = (e) => {
    const { name, companyMailID, companyName, title, phoneNumber, requirementDescription, loading } = this.state;
    if (name !== '' && companyMailID !== '' && companyName !== '' && title !== '' && phoneNumber !== '' && requirementDescription !== '') {
      this.setState({ loading: true });
      if (!this.canBeSubmitted()) {
        e.preventDefault();
        alert('enter valid data');
        return;
      } else {
        const details = {
          name: name,
          companyMailID: companyMailID,
          companyName: companyName,
          title: title,
          phoneNumber: phoneNumber,
          requirementDescription: requirementDescription,
        };
        Axios.post(CONFIG.apiURL + '/insertB2BDetails', details)
          .then((response) => {
            if (response.status === 200) {
              this.setState({
                loading: false,
                emailStatus: 'success',
                replyMessage: 'Thanks for getting in touch. We get back to you shortly.',
              });

              setTimeout(() => {
                this.setState({
                  name: '',
                  companyMailID: '',
                  companyName: '',
                  title: '',
                  phoneNumber: '',
                  requirementDescription: '',
                });
              }, 1500);

              return response.data;
            } else {
              this.setState({
                buttonLoading: false,
                emailStatus: 'fail',
                replyMessage: 'Oops!! Something went wrong! Please try again later.',
              });
              setTimeout(() => {
                this.setState({
                  emailStatus: false,
                });
              }, 1500);
              throw new Error('Something went wrong');
            }
          })
          .catch((error) => {
            this.setState({
              buttonLoading: false,
              emailStatus: 'fail',
              replyMessage: 'Oops!! Something went wrong! Please try again later.',
            });
            setTimeout(() => {
              this.setState({
                emailStatus: false,
              });
            }, 1500);
            console.error(error);
          });
      }
    } else {
      this.setState({
        errorStatus: true,
        replyMessage: 'Please provide all details',
      });
    }
  };

  handleHeaderSnackbar = () => {
    this.setState({ headerSnackbar: false });
  };

  handleYearEndOffer = () => {
    this.setState({ yearEndOffer: false });
  };

  handleScroll = () => {
    this.setState({ scrolling: true });
    let top = window.scrollY <= 0;
    if (top === true) this.setState({ scrolling: false });
  };

  render() {
    const { history } = this.props;
    const { browser, infoStatus, name, companyName, companyMailID, title, phoneNumber, requirementDescription, loading, headerSnackbar, yearEndOffer, scrolling } = this.state;
    const browserList = ['Microsoft Internet Explorer', 'Microsoft Edge', 'Apple Safari'];
    const browserSupport = browserList.includes(browser);
    const cloudFront = CONFIG.cloudFront;

    return (
      <Fragment>
        <Helmet>
          <title>Log2Base2&reg; for Business</title>
          <meta name="description" content="Visualize programming, data structures & algorithms and prepare for the coding interview. Join for Free!" />
          {process.env.REACT_APP_STAGE === 'prod' ? <meta name="robots" content="index, follow" /> : <meta name="robots" content="noindex, nofollow" />}
          {process.env.REACT_APP_STAGE === 'prod' ? <meta name="googlebot" content="index" /> : <meta name="googlebot" content="noindex" />}
        </Helmet>

        {headerSnackbar && <HeaderSnackbar handleHeaderSnackbar={this.handleHeaderSnackbar} />}
        <Header fixed={true} headerSnackbar={headerSnackbar} handleSnackBarClose={this.handleSnackBarClose} isScrolling={scrolling} />
        <section className="banner-container" style={{ paddingBottom: '50px' }}>
          <div className="inner-section">
            <div className="col-md-12 row mx-0 px-0">
              <div className="col-md-6 col-lg-7 px-0 px-sm-3 b2b-homepage-content d-flex flex-column align-items-sm-center justify-content-md-center align-items-md-start">
                <h1>Train & upskill your team!</h1>
                <p className="b2b-homepage-text fs-20 pb-2 headingFont weight-600">Improve their data structures & problem solving skills with Log2Base2.</p>
                <p className="b2b-homepage-text responsiveTxt darkGreyTxt">
                  With Log2Base2, your team can learn programming and start writing code efficiently with their algorithmic skills.
                </p>
                <Button primary isfromb2b={true} onClick={() => this.focusForm()} style={{ marginTop: '25px' }}>
                  Get a Quote {false && <ButtonLoader />}
                </Button>
              </div>

              <div id="b2bForm" className="col-md-6 col-lg-5 px-0 px-sm-3 formMobileTop">
                <div style={{ backgroundColor: 'white', borderRadius: 8, boxShadow: '0px 2px 10px 0px var(--greyShadowColor)' }}>
                  <div className="formPadding">
                    <InputField
                      type="text"
                      maxLength={30}
                      ref={this.input1Focus.ref}
                      placeholder="Name"
                      value={name}
                      autoFocus={true}
                      onChange={(e) => {
                        this.setState({ name: e.target.value });
                      }}
                    />
                    <Input
                      type="text"
                      ref={this.input2Focus.ref}
                      maxLength={50}
                      placeholder="Company Name"
                      value={companyName}
                      onChange={(e) => {
                        this.setState({ companyName: e.target.value });
                      }}
                    />
                    <Input type="email" placeholder="Company Email ID" value={companyMailID} onChange={(e) => this.validateEmail(e.target.value)} />
                    <Input
                      type="text"
                      maxLength={50}
                      placeholder="Title"
                      value={title}
                      onChange={(e) => {
                        this.setState({ title: e.target.value });
                      }}
                    />
                    <Input type="tel" placeholder="Phone Number" value={phoneNumber} onChange={(e) => this.validateMobile(e.target.value)} />
                    <TextArea
                      maxLength={500}
                      type="text"
                      placeholder="Describe your requirement"
                      value={requirementDescription}
                      onChange={(e) => {
                        this.setState({ requirementDescription: e.target.value });
                      }}
                    />
                    <Button style={{ width: '100%' }} onClick={this._submitData} primary>
                      Get a Quote {loading && <ButtonLoader />}
                    </Button>
                    {this.state.replyMessage !== '' ? (
                      <p className="fs-14 pt-2" style={{ color: this.state.errorStatus ? 'var(--danger)' : 'green' }}>
                        {this.state.replyMessage}
                      </p>
                    ) : (
                      <p className="fs-14 text-muted pt-2">We will contact you within 24 hours.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <Courses cloudFront={cloudFront} history={history} /> */}
        <Footer />
        {/*{infoStatus && <InfoBar type={'promoCode'} history={history} handleInfoBar={this.handleInfoBar} handlePromocodePricing={() => history.push('/pricing')} />}*/}
        {/* yearEndOffer && <InfoBar type={'originalsBottomBar'} handleInfoBar={this.handleYearEndOffer} /> */}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ User }) => ({
  userID: User.username,
  name: User.name,
  email: User.email,
});

export default connect(mapStateToProps, null)(Home);
